;(function (angular) {
  'use strict'

  angular.module('kilo.routes', [
    'kilo.routes.invoice',
    'kilo.routes.creditnote',
    'kilo.routes.preferences',
    'kilo.routes.product',
    'kilo.routes.product-pack',
    'kilo.routes.quote',
    'kilo.routes.entity',
    'kilo.routes.inbox',
    'kilo.routes.order',
    'kilo.routes.dashboard',
    'kilo.routes.bpu',
    'kilo.routes.subcontractor',
    'kilo.routes.pennylane'
  ])
})(window.angular)
